define('controllers/packs',[
    'controllers/base/controller',
    'views/pages/packs',
    'models/pages/packs'
], function(
    Controller,
    PacksPageView,
    PacksPageModel
) {
    'use strict';

    var PacksController = Controller.extend({
        show: function(params) {
            var model = new PacksPageModel({
                tradeId: params.tradeId,
                inViewCurrency: params.currency === 'view' ? true : false,
                pricePercent: params.pricePercent === 'percent' ? true : false
            });

            this.view = new PacksPageView({
                model: model
            });

            model.load(true);
        },
        showBase: function(params) {
            params.currency = 'base';
            this.show.apply(this, arguments);
        },
        showView: function(params) {
            params.currency = 'view';
            this.show.apply(this, arguments);
        }
    });

    return PacksController;
});

